import { RefObject } from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';

export function Footer({ elementRef }: { elementRef: RefObject<HTMLElement> }) {
  const dateObj = new Date();
  return (
    <footer ref={elementRef} className="footer">
      <Container className="py-1 tw:text-sm">
        <Row className="justify-content-between align-items-center">
          <Col className="d-flex rights-and-social-nav-wrapper" xl={6}>
            <div className="rights-and-social-nav">
              <div className="text-center">
                © {dateObj.getFullYear()} Send-it Healthcare Inc. All rights reserved.
              </div>
            </div>
          </Col>
          <Col className="d-flex links-nav-wrapper" xl={6}>
            <Nav>
              <NavDropdown className="text-center" title="Support">
                <NavDropdown.Item
                  as={Link}
                  target="_blank"
                  to="https://docs.google.com/forms/d/e/1FAIpQLSd2236EHQCrfhPqsbclegK7OCggNizrKXlIZu7xJjt-uJTydw/viewform?usp=header"
                >
                  Send a Report
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
